import { createRandom } from "./collageLayout";
import { HeartShape, loveTones } from "./hearts";

const random = createRandom(214);
const between = (min, max) => min + random() * (max - min);

const bokehSpots = Array.from({ length: 10 }, (_, index) => ({
  id: `bokeh-${index}`,
  left: `${between(-10, 90)}%`,
  top: `${between(-10, 85)}%`,
  size: `${between(16, 42)}vmax`,
  tone: index % 3 === 0 ? "rgba(255, 252, 248, 0.75)" : index % 3 === 1 ? "rgba(244, 182, 194, 0.55)" : "rgba(249, 213, 221, 0.7)",
  driftX: `${between(-6, 6)}vw`,
  driftY: `${between(-6, 6)}vh`,
  duration: `${between(16, 30)}s`,
  delay: `${-between(0, 20)}s`,
}));

const floatingHearts = Array.from({ length: 13 }, (_, index) => {
  const duration = between(15, 28);
  return {
    id: `heart-${index}`,
    left: `${(index / 13) * 100 + between(0, 6)}%`,
    size: between(9, 22),
    color: loveTones[index % 3 === 0 ? 3 : index % 2 === 0 ? 1 : 0],
    opacity: between(0.28, 0.6),
    sway: `${between(14, 40)}px`,
    duration: `${duration}s`,
    delay: `${-between(0, duration)}s`,
  };
});

const fallingPetals = Array.from({ length: 9 }, (_, index) => {
  const duration = between(17, 30);
  return {
    id: `petal-${index}`,
    left: `${(index / 9) * 100 + between(0, 8)}%`,
    size: between(10, 17),
    sway: `${between(30, 90) * (index % 2 ? 1 : -1)}px`,
    spin: `${between(220, 520) * (index % 2 ? -1 : 1)}deg`,
    opacity: between(0.4, 0.75),
    duration: `${duration}s`,
    delay: `${-between(0, duration)}s`,
  };
});

export default function LoveAmbient() {
  return (
    <div className="ambient" aria-hidden="true">
      {bokehSpots.map((spot) => (
        <div
          key={spot.id}
          className="ambient-bokeh"
          style={{
            left: spot.left,
            top: spot.top,
            width: spot.size,
            height: spot.size,
            "--tone": spot.tone,
            "--drift-x": spot.driftX,
            "--drift-y": spot.driftY,
            animationDuration: spot.duration,
            animationDelay: spot.delay,
          }}
        />
      ))}
      {fallingPetals.map((petal) => (
        <div
          key={petal.id}
          className="ambient-petal"
          style={{
            left: petal.left,
            width: petal.size,
            height: petal.size * 0.78,
            "--sway": petal.sway,
            "--spin": petal.spin,
            "--petal-opacity": petal.opacity,
            animationDuration: petal.duration,
            animationDelay: petal.delay,
          }}
        />
      ))}
      {floatingHearts.map((heart) => (
        <div
          key={heart.id}
          className="ambient-heart"
          style={{
            left: heart.left,
            width: heart.size,
            height: heart.size,
            color: heart.color,
            "--sway": heart.sway,
            "--heart-opacity": heart.opacity,
            animationDuration: heart.duration,
            animationDelay: heart.delay,
          }}
        >
          <HeartShape />
        </div>
      ))}
    </div>
  );
}
